/*
* Deck.js
*
* Deck object class and associated functions for handling deck objects
*/

// Droppable options for decks. Updates containing div to a container object


var SetWrapperHeight = function () {
	var xMeter = GetCurrentDeckLength();
	var xPixel = $(".wrapper").width();
	var pixelPrMeter = xPixel / xMeter;

	var yPixel = pixelPrMeter * GetDeckAreaHeight();

	$(".wrapper").css({minHeight: (yPixel + 10) + "px"});
};


/*
 * Initialises all the decks to be displayed
 */
function InitialiseDecks(p_json_decks) {
  // Add the ship's decks
	g_deck_list = {};
  $.each( p_json_decks, function( p_i, p_obj ) {

    var l_new_deck = new deck(p_obj);
		g_deck_list[l_new_deck.id] = l_new_deck;
		g_current_deck = g_deck_list[l_new_deck.id];
	  l_new_deck.InitialiseVisual( G_CONTAINING_DIV );


	var l_overlay_content = '';
	var l_vertical_line = g_deck_list[l_new_deck.id]['vertical_line_range'];
	if(l_vertical_line){
		l_vertical_line = parseFloat(l_vertical_line);
	}
	if(l_vertical_line && l_vertical_line >= 0 ) {
		for( var l_i=l_vertical_line; l_i < l_new_deck.length; l_i += l_vertical_line) {

			var width = (100 / l_new_deck.length) * l_vertical_line;

			l_overlay_content = l_overlay_content + '<div class="deck_overlay_lines" style="height:100%;width:' +width+'%">' +
				'<span class="deck_overlay_text">' + (l_i).toFixed(0) + '</span>' +
				'<span class="deck_overlay_text"></span>' +
				'</div>';
			//<div class="deck_overlay_text" style="left:' + (l_i * g_deck_scale + 3) + 'px;">' + l_i.toFixed(1) + '</div>
		}
	}
	else if(p_obj.deck_lines) {
	  var currentPresentage = 0;
	 var currentLength = 0;
	  var deck_lines = JSON.parse(p_obj.deck_lines);

	  for(var i=0; i < deck_lines.length; i++) {
        var l_vertical_line = deck_lines[i][1];

		var presentageWidth = (100 / l_new_deck.length) * l_vertical_line;

		if(currentPresentage + presentageWidth > 100){
			presentageWidth = 100 - currentPresentage;
			currentLength = g_current_deck.length;

		}
		else{
			currentLength = currentLength + l_vertical_line;
		}

		  l_overlay_content = l_overlay_content + '<div class="deck_overlay_lines" style="height:100%;width:' +presentageWidth+'%">' +
				  '<span class="deck_overlay_text">' + (currentLength).toFixed(1) + '</span>' +
				  '<span class="deck_overlay_text"> ' +  deck_lines[i][0] + '</span>' +
			  '</div>';

		  currentPresentage = currentPresentage + presentageWidth;
	  }
	}
	var l_overlay = '<div id="' + l_new_deck.id + '_overlay" class="deck_overlay">' + l_overlay_content + '</div>';
	$('#' + l_new_deck.id).append( l_overlay );


		var deckInteractable = interact("#deck").draggable({})
			.on('tap', function (event) { //Setting this as draggable fixes a weird bug in Interact where tap, doubletap stopped working.
				if($(event.target).hasClass('deckstate_container')){
					return;
				}
				VRC.ContainerPopoverView.hide();
				if(g_selected_container){
					var $containerDiv = $(g_selected_container.divID);
					$containerDiv.removeClass('highlighted');
				}})

			.on('doubletap', function(event){

				if($(event.target).hasClass('deckstate_container') ||  $(event.target).closest('.deckstate_container').length > 0 || ($(event.target).closest('.popover-content').length > 0)){
					return;
				}

				var l_relativeX = event.pageX - $('#deck').offset().left;
				var l_relativeY = event.pageY - $('#deck').offset().top;

				var clickXPos = GetLengthPosFromPixel(l_relativeX);
				var clickYPos = GetWidthPosFromPixel(l_relativeY);
				var deckId;
				if(clickXPos <= GetCurrentDeckLength() && clickYPos <= GetCurrentDeckWidth()){
					deckId = l_new_deck.id;
				}
				else{
					deckId = 'transit_deck';
				}
				g_dbl_container_pos = [clickXPos, clickYPos, deckId];

				OpenContainerDialog();

				VRC.ContainerEditModal.show();
		});

		deckInteractable.styleCursor(false);


	AddDeckConstraints(l_new_deck, p_obj.constraints );

  });

  $('#deck').append('<div style="clear:both;"></div>');


  var l_transit_in = new deck( {id:'transit_area', type: 'loadout', length: 35, width: 15, vertical_line_range: 0} );
  l_transit_in.InitialiseVisual( G_CONTAINING_DIV );
  var l_transit_out = new deck( {id:'outgoing_area', type: 'offload', length: 15, width: 15, vertical_line_range:0} );
  l_transit_out.InitialiseVisual( G_CONTAINING_DIV );

  // Add text to transit areas
  $(l_transit_in.divID).html('<div id="transit_area_text" class="transit_text"></div><div class="transit_header_text">LOADING AREA</div>');
  $(l_transit_out.divID).html('<div id="outgoing_area_text" class="transit_text"></div><div class="transit_header_text">OFFLOADING AREA</div>');

	var $deck_middle_area = $('#deck__middle_area');
	if($deck_middle_area.length === 0){
		$('#deckWrapper').after(WELL.Handlebars.VRC.deck_middle_area({}));
	}
	else{
		$deck_middle_area.replaceWith(WELL.Handlebars.VRC.deck_middle_area({}));
	}

	interact(".deckarea").dropzone({
		ondrop: function (event) {
			var dropZone = event.target;
			var draggedItem = event.relatedTarget;

			var l_this_id = $(dropZone).attr('id');
			var l_draggable_id = $(draggedItem).attr('id');

			if (g_container_list[l_draggable_id] === undefined || l_this_id === undefined) {
				return;
			}
			g_container_list[l_draggable_id].deckID = l_this_id;
			if (l_this_id == 'outgoing_area') {
				g_container_list[l_draggable_id].colour = G_CONTAINER_COLOURS['OUTGOING'];
				$(g_container_list[l_draggable_id].divID).css('background-color', G_CONTAINER_COLOURS['OUTGOING']);
			}
			else {
				g_container_list[l_draggable_id].colour = SetContainerColour(g_container_list[l_draggable_id]);
				$(g_container_list[l_draggable_id].divID).css('background-color', g_container_list[l_draggable_id].colour);
			}
			UpdateColorMap();
		}
	}

	);
	VRC.DeckStateActionsView.init();


	$(".wrapper").on('dragstart', function (event) {
		event.preventDefault();
	});

	SetWrapperHeight();

	$(window).bind('resizeEnd', function() {
		SetWrapperHeight();
	});
}

$(window).resize(function() {
	if(this.resizeTO) clearTimeout(this.resizeTO);
	this.resizeTO = setTimeout(function() {
		$(this).trigger('resizeEnd');
	}, 1000);
});
/*
 * Adds deck constraints that are not movable areas
 */
function AddDeckConstraints(deck, constraints) {

	var $deck = $('#' + deck.id);
	var deckOverlay = $('<div></div>');
	$.each(constraints, function (key, constraint) {
		var newConstraint = {};
		newConstraint.width = CalculatePresentageOfTotal(GetCurrentDeckLength(), constraint.width);
		newConstraint.height = CalculatePresentageOfTotal(GetDeckAreaHeight(), constraint.height);
		newConstraint.x = CalculatePresentageOfTotal(GetCurrentDeckLength(), constraint.x);
		newConstraint.y = CalculatePresentageOfTotal(GetDeckAreaHeight(), constraint.y);
		newConstraint.shape = constraint.shape;
		newConstraint.image = constraint.image;
		newConstraint.type = constraint.type;
		newConstraint.name = constraint.name;

		$deck.append(WELL.Handlebars.VRC.constraint(newConstraint));
	});
}



/*
* Visual initialisation of the deck object
*/
deck.prototype.InitialiseVisual = function ( p_containingID ) {
	if( $(this.id).length ) {
	$(this.divID).remove();  // remove container first if visual representation already exists
	}

	if(this.divID === '#transit_area' || this.divID === '#outgoing_area'){
		if(g_current_deck !== undefined){
			var height = (g_current_deck.width / g_current_deck.length) * 100;
		}
	}
	else{
		var height = (this.width / this.length) * 100;
	}

	var l_attributes = 'id="' + this.id + '" class="deckarea" style="padding-top:' + height + '%;"';
	var l_div = '<div ' + l_attributes + '></div>';
	$( p_containingID ).append( l_div );

	// store the position
	this.position.x = $('#' + this.id ).position().left;
	this.position.y = $('#' + this.id ).position().top;
}

/*
* Constructor for deck object
*/
function deck( p_params ) {
  this.id = p_params.id;
  this.type = p_params.type;

  this.divID = '#' + p_params.id;

  this.length = p_params.length;
  this.width = p_params.width;

  this.vertical_line_range = p_params.vertical_line_range === undefined ? 0 : p_params.vertical_line_range;
  this.deck_lines = p_params.deck_lines === undefined ? "" : p_params.deck_lines;

  this.constraints = p_params.constraints;

  this.position = {};
  this.position.x;
  this.position.y;
}


function CalculatePresentageOfDeckLength(value, includePresentage){

	return CalculatePresentageOfTotal(GetCurrentDeckLength(), value, includePresentage);
}

function CalculatePresentageOfDeckWidth(value, includePresentage){
	return CalculatePresentageOfTotal(GetDeckAreaHeight(), value, includePresentage);
}

function GetCurrentDeckLength() {
	var length = 0;
	if(g_current_deck){
		length = g_current_deck.length
	}
	return length;
}

function GetCurrentDeckWidth() {
	return g_current_deck.width;
}

function GetDeckAreaHeight() {
	var width = 0;
	if(g_current_deck){
		var margin = 5;
		var heightMargin = 1 + (margin / $("#"+g_current_deck.id).width());
		width =  (g_current_deck.width * 2) * heightMargin;
	}
	return width;
}

var GetXPostitionInPresentage = function(x){
	return (x / $("#deck").outerWidth() * 100)+'%';
};

var GetYPostitionInPresentage = function(y){
	return (y / $("#deck").outerHeight() * 100)+'%';
};

var GetLengthPosFromPixel= function(x){
    return (x / $("#deck").outerWidth() * GetCurrentDeckLength());
};

var GetWidthPosFromPixel= function(y){
    return (y / $("#deck").outerHeight() * GetCurrentDeckWidth())*2;
};
